import { PlayerRole } from "../../../redux/players/playersSlice";
import axios from "../../apiFc24";

export const getPlayerRoles = async () => {
  const res = await axios.get<PlayerRole[]>("/squad-builder/player-roles");
  return res.data;
};
